import { NavOptionType } from "apps/console/components/navigation/context/type";
import { getApiQueryKey, useGetApiData } from "shared/datalayer";
import PublicApi from "shared/enums/PublicApi";
import { ApiUIFilter } from "./types";

export function getSideFilterQueryKey() {
  return getApiQueryKey(PublicApi.GET_SIDE_FILTER);
}

export function useGetSideFilterConfig() {
  return useGetApiData<ApiUIFilter>(PublicApi.GET_SIDE_FILTER);
}

export function useGetSideFiltersForScreen({
  contextId,
  screenType,
  successHandler
}: {
  contextId: string;
  screenType: string;
  successHandler?: (data: NavOptionType) => void;
}) {
  return useGetApiData<NavOptionType>(
    PublicApi.GET_SIDE_FILTERS_WITH_COUNT,
    { params: { contextId, screenType } },
    { onSuccess: data => successHandler?.(data) }
  );
}
